<template>
	<vue-recaptcha ref="recaptcha" v-if="recaptcha_created" :sitekey="captcha_key" @verify="response => $emit('verify', response)"></vue-recaptcha>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'

const RECAPTCHA_URL = 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit'
const RECAPTCHA_ID = 'recaptcha-script'

export default {
    name: 'recaptcha',
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            recaptcha_created: false,
            captcha_key: window.APP_CONFIG.CAPTCHA_KEY,
            // captcha_key: '6LcW6HwUAAAAALDqnuynqUSVlPuGrlkqdtvx27pi',
        }
    },
    methods: {
        initRecpatcha() {
            if (this.isRecaptchaInitialized()) {
                this.recaptcha_created = true
                return true
            }

            this.addRecaptchaToHead()

            window.vueRecaptchaApiLoaded = () => {
                this.recaptcha_created = true
            }
        },
        isRecaptchaInitialized() {
            const scripts = document.getElementsByTagName('script')

            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src === RECAPTCHA_URL) {
                    return true
                }
            }
            
            return false
        },
        addRecaptchaToHead() {
            let script = document.createElement('script')
            script.setAttribute('async', '')
            script.setAttribute('defer', '')
            script.id = RECAPTCHA_ID
            script.src = RECAPTCHA_URL
            document.getElementsByTagName('head')[0].appendChild(script)
        },
        reset() {
            return this.$refs['recaptcha'].reset;
        },
    },
    created() {
        this.initRecpatcha()
    },
}
</script>